import { generateApiUrl } from "@/shared/utils";
/* eslint-disable no-console */
/* eslint-disable no-useless-catch */
import httpService from "@/shared/http";
import { pathOr } from "ramda";

export const getWashup = async (centerExecuteId) => {
  try {
    const url = generateApiUrl(["kanoon", "washup"], [centerExecuteId]);
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const statusId = pathOr(null, ["canter_execute_status", "id"], data);
    const executiveRoleId = pathOr(null, ["user_executive_role", "id"], data);
    const items = pathOr([], ["items"], data);
    return {
      statusId,
      executiveRoleId,
      items,
    };
  } catch (error) {
    throw error;
  }
};
export const getCompetencyOverview = async (centerExecuteId) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "center_execute_competency_overview"],
      [centerExecuteId]
    );
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    return { items: data };
  } catch (error) {
    throw error;
  }
};
export const setCenterExecuteCaseStatus = async (
  centerExecuteId,
  caseId,
  caseStatusId
) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "center_execute_case_status"],
      [centerExecuteId, caseId]
    );
    const payload = { status: caseStatusId };
    const response = await httpService.patch(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const getCandidateOverview = async (centerExecuteId, candidateId) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "centerExecuteCandidateOverview"],
      [centerExecuteId, candidateId]
    );
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const executiveRoleId = pathOr(null, ["executive_role", "id"], data);

    const candidate = pathOr(null, ["candidate"], data);

    let competencies = pathOr([], ["competency"], data);
    competencies = competencies.map((item) => {
      return {
        id: pathOr(null, ["id"], item),
        overviewId: pathOr(null, ["overview_id"], item),
        centerExecuteCaseId: pathOr(null, ["center_execute_case_id"], item),
        name: pathOr(null, ["name"], item),
        score: pathOr(null, ["score"], item),
        average: pathOr(null, ["average"], item),
        overall: pathOr(null, ["overall"], item),
        strengthAndDevelopment: pathOr(
          null,
          ["strength_development_area"],
          item
        ),
      };
    });

    let exercises = pathOr([], ["exercise"], data);
    exercises = exercises.map((item) => {
      return {
        id: pathOr(null, ["id"], item),
        overviewId: pathOr(null, ["overview_id"], item),
        centerExecuteCaseId: pathOr(null, ["center_execute_case_id"], item),
        name: pathOr(null, ["name"], item),
        assessor: pathOr(null, ["assessor"], item),
        score: pathOr(null, ["score"], item),
        overall: pathOr(null, ["overall"], item),
        strengthAndDevelopment: pathOr(
          null,
          ["strength_development_area"],
          item
        ),
      };
    });

    const itemsData = pathOr([], ["items"], data);
    const items = itemsData.map((item) => {
      const competencyId = pathOr(null, ["competency_id"], item);
      const competency = competencies.find(({ id }) => id === competencyId);

      const exerciseId = pathOr(null, ["exercise_id"], item);
      const exercise = exercises.find(({ id }) => id === exerciseId);

      return {
        id: pathOr(null, ["id"], item),
        caseId: pathOr(null, ["case_id"], item),
        competencyId: pathOr(null, ["competency_id"], item),
        exerciseId: pathOr(null, ["exercise_id"], item),
        score: pathOr(null, ["score"], item),
        recommendedScore: pathOr(null, ["score_suggest"], item),
        evidenceLogCount: pathOr(0, ["evidence_log_count"], item),
        finalDescription: pathOr("", ["final_description"], item),
        description: pathOr("", ["description"], item),
        isAbsent: pathOr(false, ["is_absent"], item),
        isChangeFinalDescription: pathOr(
          false,
          ["is_change_final_description"],
          item
        ),
        competency: competency || null,
        exercise: exercise || null,
      };
    });

    return { executiveRoleId, candidate, items, exercises, competencies };
  } catch (error) {
    throw error;
  }
};
export const setFinalScore = async ({
  centerExecuteId,
  caseId,
  competencyId,
  finalScore,
  finalDescription,
  description,
  location,
}) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "centerExecuteCaseCompetency"],
      [centerExecuteId, caseId, competencyId]
    );
    const payload = {
      score: finalScore,
      final_description: finalDescription,
      description,
      location,
    };
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const setConclusionFinalScore = async ({
  centerExecuteId,
  candidateId,
  overviewId,
  strengthAndDevelopment,
  overall,
  finalScore,
  centerExecuteCaseId,
}) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "centerExecuteCandidateOverviewId"],
      [centerExecuteId, candidateId, overviewId]
    );
    const payload = {
      strength_development_area: strengthAndDevelopment,
      overall,
      score: finalScore,
      center_execute_case_id: centerExecuteCaseId,
    };
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
